export default {
  en: {
    Training: 'Training',
    training: {
      welcome: 'Here you will find the best training tools to become fluent in radio communication and general aviation.',
      hint: 'We will add more training tools in the future, so stay tuned! You are very welcome to suggest new training tools.',
      spelling:'Train with random spelling exercises',
      spellingdescription: 'Train with diverse spelling exercises to not get overwhelmed by the radio alphabet.',
      listening:'Prepare for your radio license in interactive courses.',
    }
  },
  de: {
    Training: 'Training',
    training: {
      welcome: 'Hier findest du die besten Trainingswerkzeuge, um fließend in der Funkkommunikation und der allgemeinen Luftfahrt zu werden.',
      hint: 'Wir werden in Zukunft weitere Trainingswerkzeuge hinzufügen, also bleib dran! Du bist herzlich eingeladen, neue Trainingswerkzeuge vorzuschlagen.',
      spelling: 'Trainiere mit zufälligen Rechtschreibübungen',
      spellingdescription: 'Trainiere mit verschiedenen Rechtschreibübungen, um nicht von dem Funkalphabet überwältigt zu werden.',
      listening: 'Bereite dich mit interaktiven Kursen auf deine Funklizenz vor.',
    }
  },
  at: {},
  es: {
    Training: 'Entrenamiento',
    training: {
      welcome: 'Aquí encontrarás las mejores herramientas de entrenamiento para volverte fluido en la comunicación por radio y en aviación general.',
      hint: '¡Añadiremos más herramientas de entrenamiento en el futuro, así que mantente atento! Eres muy bienvenido a sugerir nuevas herramientas de entrenamiento.',
      spelling: 'Entrena con ejercicios de ortografía aleatorios',
      spellingdescription: 'Entrena con diversos ejercicios de ortografía para no sentirte abrumado por el alfabeto radiofónico.',
      listening: 'Prepárate para tu licencia de radio con cursos interactivos.',
    }
  },
  uk: {
    Training: 'Тренування',
    training: {
      welcome: 'Тут ви знайдете найкращі інструменти для тренування, щоб стати вільним у радіозв\'язку та загальній авіації.',
      hint: 'Ми додамо більше інструментів для тренування в майбутньому, тому слідкуйте за оновленнями! Ви дуже бажані, щоб запропонувати нові інструменти для тренування.',
      spelling: 'Тренуйтеся з випадковими вправами на правопис',
      spellingdescription: 'Тренуйтеся з різноманітними вправами на правопис, щоб не відчувати себе перевантаженим радіоалфавітом.',
      listening: 'Підготуйтеся до вашої радіоліцензії в інтерактивних курсах.',
    }
  }
}
